import { Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface ShiftEndedBottomSheetProps {
  modalState: UseModalState;
  clockOutModalState: UseModalState;
}

export function ShiftEndedBottomSheet(props: ShiftEndedBottomSheetProps) {
  const { modalState, clockOutModalState } = props;

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            onClick={() => {
              clockOutModalState.openModal();
              modalState.closeModal();
            }}
          >
            Clock out
          </Button>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={() => modalState.closeModal()} />}
      modalState={modalState}
    >
      <BottomSheetIllustrationContent
        hasFooter
        title="Your shift has ended"
        description={
          <Stack gap={6}>
            <Text semibold variant="body1" color={(theme) => theme.palette.text.secondary}>
              Your scheduled shift time is over. Please clock out to submit your timesheet.
            </Text>
            <Text semibold variant="body1" color={(theme) => theme.palette.text.secondary}>
              If you worked beyond your scheduled time, you can submit a Missed Punch Request after
              clocking out.
            </Text>
          </Stack>
        }
        illustrationType="hours-limit"
      />
    </BottomSheet>
  );
}
